import { Component } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';

@Component({
	selector: 'app-tourism-events-service',
	templateUrl: './tourism-events-service.component.html',
	styleUrls: ['./tourism-events-service.component.css'],
})
export class TourismEventsServiceComponent extends TourismEventsComponent {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		category: '',
		text_program: '',
	};
	fault = '';
	faultError = false;

	protected defaultValues() {
		this._serviceEvent.getOrganization();
		this._serviceEvent.organization.subscribe((result) => {
			this.event.client = result;
			this.event.clientEvent = {
				client: result.id,
				event: null,
				isOrganization: '1',
			};
		});
		this.event.status = 'PRELIMINARY';
		this.event.type = 'EVENT';
		this.event.category = CategoryEvent.SERVICE;
	}

	protected convertDataOnSave(data) {
		data.text_program = 'Kontakt do serwisu:\n' + this.event.text_program + '\nUsterka:\n' + this.fault;
		data.startPlace = this.event.name;
		data.endPlace = this.event.name;
		return data;
	}
}
